module.exports = __webpack_public_path__ + "media/10.ea2e8f08.mp3";